export const QueryKeys = {
	content: 'content',
	products: 'products',
	productTypes: 'product-types',
	componentCategories: 'component-categories',
	components: 'components',
	attributes: 'attributes',
	attributeValues: 'attribute-values',
} as const;

export type QueryKeys = (typeof QueryKeys)[keyof typeof QueryKeys];
